<script setup lang="ts">
/**
 * The ticks of an own message, for the `#time` slot of `NxChatMessage`: one for
 * sent, two for delivered, two in the read colour for read. `label` names the
 * status for assistive technology and the tooltip.
 */
import Check from 'lucide-vue-next/dist/esm/icons/check.js'; import CheckCheck from 'lucide-vue-next/dist/esm/icons/check-check.js';

defineProps<{
  status: 'sent' | 'delivered' | 'read';
  label: string;
}>();
</script>

<template>
  <span
    class="nx-chat-msg-status"
    :class="`is-${status}`"
    role="img"
    :title="label"
    :aria-label="label"
    :data-status="status"
  >
    <Check v-if="status === 'sent'" aria-hidden="true" />
    <CheckCheck v-else aria-hidden="true" />
  </span>
</template>

<style scoped>
.nx-chat-msg-status {
  display: inline-flex;
  flex: none;
  color: inherit;
}
.nx-chat-msg-status :deep(svg) {
  width: 1.35em;
  height: 1.35em;
}
/* Own bubbles are the brand colour, so „read“ cannot be blue: the light teal
   stands out on them. */
.nx-chat-msg-status.is-read {
  color: var(--nxt-hue-teal-border);
}
[data-theme='dark'] .nx-chat-msg-status.is-read {
  color: var(--nxt-hue-teal-fg);
}
</style>
